var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('v-app',[_c('tool-bar',{attrs:{"showMenu":_vm.showMenu}}),_c('div',{staticClass:"content"},[_c('router-view'),_c('portal-target',{attrs:{"name":"portal-loadable"}})],1),_c('portal-target',{attrs:{"name":"portal-menu"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }